<template>
  <div class="layout home" :class="isSafari?'safari_home':''">
    <div class="live 111111">
      <navigation v-if="roomInfo"></navigation>
      <!-- 直播背景 -->
      <img class="live-bg" :class="{hide: showBg}" :style="liveStatus === 3 || liveStatus === 0 ||liveStatus === 2?'filter: blur(0.1rem);':''" src="https://exshow.oss-cn-shanghai.aliyuncs.com/exshow/imgs/202004/c63b3835baaa4238837ad76230029e6d.png" v-load="'oHallLiveCover'" style="opcity: 0.4" />
      <!-- 遮罩层 -->
      <div class="live_mask" v-if="liveStatus === 3 || liveStatus === 0 ||liveStatus === 2"></div>
      <!-- 直播未开始 -->
      <liveIng v-if="liveStatus === 0"></liveIng>
      <!-- 直播tool -->
      <liveTool :liveStatus="liveStatus"></liveTool>
      <!-- 热榜排行：直播开始前和结束后出现 -->
      <hotRank v-if="liveStatus === 3"></hotRank>
      <!--品牌交流 -->
      <!-- <liveExchange></liveExchange> -->

      <!--观众登记  -->
      <liveInfo ref="liveInfo" v-if="(liveStatus === 1||liveStatus === 2) "></liveInfo>

      <!-- 直播（结束） -->
      <liveEnd v-if="liveStatus === 3"></liveEnd>

      <!-- 主播出走 -->
      <liveAway v-if="liveStatus === 2"></liveAway>
      <!-- 顶部人数 -->
      <livePeople v-if="roomid" ref="livePeople"></livePeople>
      <!-- 直播背景 -->
      <liveVideo v-if="liveStatus === 1 && liveUrl && !isBlack" :url="liveUrl" :cover="option.cover" :liveStatus="liveStatus" :showBg="showBg"></liveVideo>

      <!-- 直播底部 -->
      <barrage id="barrage" ref="barrage" v-if="!isBlack"></barrage>
      <crowdFooter @watchliveSend="send" v-if="!isBlack"></crowdFooter>
      <layoutFooter></layoutFooter>
    </div>
  </div>
</template>

<script>
import liveExchange from "@/components/live-exchange/index";
import hotRank from "@/components/hot-rank/index";
import liveEnd from "@/components/live-end/index";
import liveTool from "@/components/live-tool/index";
import livePeople from "@/components/live-people/index";
import liveAway from "@/components/live-away/index";
import liveIng from "@/components/live-ing/index";
import navigation from "@/components/navigation/index";
import crowdFooter from "@/components/crowd-footer/index";
import liveInfo from "@/components/live-info/index";
import barrage from "@/components/barrage/index";
import layoutFooter from "@components/layout-footer";
import liveVideo from "@components/live-video";
import * as signalR from "@microsoft/signalr";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "exhibition",
  data () {
    return {
      liveUrl: '',
      isSafari: false,
      hub: null,
      show: true,
      showBg: true,
      isBlack: false,  //是否被拉黑
      liveStatus: 0, // 主播的直播状态  0：未开始 1：直播中 2：直播结束 3：直播断开 
    };
  },
  components: {
    layoutFooter,
    liveEnd,
    // liveExchange,
    liveAway,
    liveIng,
    livePeople,
    navigation,
    liveTool,
    crowdFooter,
    liveInfo,
    hotRank,
    barrage,
    liveVideo
  },
  computed: {
    ...mapGetters({
      // 直播状态码（LiveCode）：0：未播、1：直播中、2：暂停中、3：已结束、4：已被下架、5：取消、6：未审核通过、7：审核中、8：审核通过
      liveCode: "getLiveCode",
      api: "getApi",
      roomid: "getRoomid",
      roomInfo: "getRoomInfo",
      viewer: "getViewer",
      viewerId: "getViewerId",
      exhibitionId: "getExhibitionId",
      userId: "getUserId",
      userInfo: "getUserInfo",
      isFooterBtnShow: "getIsFooterBtnShow",
    }),
    option () {
      return {
        id: "player-con",
        height: "100%",
        width: "100%",
        useH5Prism: true,
        useFlashPrism: false,
        aliplayerSdkPath:
          "http://g.alicdn.com/de/prismplayer/2.8.2/aliplayer-min.js",
        source: this.liveUrl,
        // autoplay: true,
        isLive: true,
        cover:
          this.roomInfo.poster,
        rePlay: true,
        playsinline: true,
        preload: true,
        language: "zh-cn",
        controlBarVisibility: "always",
        //prismplayer 2.0.1版本支持的属性，主要用户实现在android 微信上的同层播放
        x5_type: "h5-page", //通过 video 属性 “x5-video-player-type” 声明启用同层H5播放器，支持的值：h5 https://x5.tencent.com/tbs/guide/video.html
        x5_fullscreen: true, //通过 video 属性 “x5-video-player-fullscreen” 声明视频播放时是否进入到 TBS 的全屏模式，支持的值：true
      };
    }
  },
  created () {
    this.init();
    this.getUser();
    this.getConfig();
  },
  mounted () {
    let userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    console.log(userAgent);
    if (userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Chrome") < 0) {
      this.isSafari = true;
    } else {
      this.isSafari = false;
    }
  },
  methods: {
    ...mapMutations({
      setRoomId: "setRoomId",
      setExhibitionId: "setExhibitionId",
    }),
    ...mapActions({
      getLiveInfoByRoomid: "getLiveInfoByRoomidNew",
      shareToWechat: "wxShare/shareToWechat",
      getConfig: "wxShare/getConfig",
      getExhibitionById: "login/getExhibitionById",
      getLiveUrl: "live/getLiveUrl",
      getUser: 'login/getUser',
      getRoomByExId: "live/getRoomByExId",
    }),
    async init () {
      const query = this.$route.query;
      const req = {
        exhibitionId: query.exhibitionId || this.exhibitionId,
        userId: this.userId,
      };
      const roomInfo = await this.getRoomByExId(req);
      if (!roomInfo) {
        this.$router.push('/404');
        return;
      }
      console.log('roomInfo', roomInfo);
      if (query.roomId) {
        this.setRoomId(query.roomId);
      } else {
        this.setRoomId(roomInfo.roomInfo.roomId);
      }
      if (query.exhibitionId) {
        this.setExhibitionId(query.exhibitionId);
      } else {
        this.setExhibitionId(query.exhibitionId);
      }
      await this.getLiveInfoByRoomid(this.roomid);
      console.log('this.roomInfo', this.roomInfo);
      console.log('this.option', this.option);
      this.getHub();
    },
    //用户发送弹幕
    send (text) {
      //  已经进入，得到直播间观众信息 
      if (!this.hub) {
        this.$toast.fail('连接失败');
        this.reContact();
        return
      }
      this.text = text;
      // console.log(this.hub,this.viewer,'发送时');
      if (this.viewer && this.viewerId) {
        var comment = {};
        comment.roomId = this.roomid;
        comment.userId = this.viewer.UserId;
        comment.userInfo = this.viewer.UserInfo;
        comment.viewerId = this.viewerId;
        comment.content = this.text;
        this.hub.invoke("ViewerComment", this.roomid, comment);
      } else {
        //未进入，先进入直播
        console.log("未发送，进入直播");
        this.viewerInit();
      }
    },
    //事件监听
    getLoadMethod () {
      const that = this;
      // 主播进入
      this.hub.on("AnchorEntryNotice", function (msg) {
        that.liveStatus = 1;
        console.log(msg);
      });
      // 主播离开
      this.hub.on("AnchorLeaveNotice", function (msg) {
        that.liveStatus = 3;
        that.showBg = true;
        console.log(msg);
      });
      // 主播结束直播
      this.hub.on("AnchorEndLiveNotice", function (msg) {
        that.liveStatus = 2;
        that.showBg = true;
      });
      //拒绝开播
      this.hub.on("RefuseAnchorBeginLiveNotice", state => {
        switch (state) {
          case -1:
            this.$toast.fail("直播审核未通过");
            break;
          case 0:
            this.$toast.fail("直播待审核");
            break;
          case 1:
            this.$toast.fail("直播已结束");
            break;
          case 2:
            this.$toast.fail("直播已取消");
            break;
          case 3:
            this.$toast.fail("直播已下架");
            break;
          default:
            this.$toast.fail("直播出现异常");
            break;
        }
      });
      // 通知观众直播已开启
      this.hub.on("AnchorBeginLiveNotice", res => {
        this.liveStatus = 1;
        if (res && res.length === 3) {
          this.liveStatus = 1;
          this.showBg = false;
          this.liveUrl = res[1]; // 直播地址

          if (this.$refs.player) {
            this.$refs.player.play();
          }
          console.log("this.liveStatus: ", res);
          console.log("this.liveUrl: ", res);
        } else {
          this.showBg = true;
        }
      });
      //观众进入响应通知
      this.hub.on("ViewerEntryResponseNotice", msg => {
        if (msg.Data.viewer) {
          this.$store.commit("setViewer", msg.Data.viewer);
          this.$store.commit("setViewerId", msg.Data.viewer.Id);
          if (msg.Data.viewer.IsBlack) {
            this.$toast.fail("您已被拉黑");
            this.isBlack = true;
          }
          if (this.text) {
            this.send(this.text);
          }
        }
        // 正在直播
        if (msg && msg.Code === 1) {
          that.showBg = false;
          that.liveUrl = msg.Data.pulls[2]; // 直播地址
          that.showBg = true;
        }
        that.liveStatus = msg.Code;
        // that.liveStatus = 3; 
        // 直播状态码（LiveCode）：0：未播、1：直播中、2：暂停中、3：已结束、4：已被下架、5：取消、6：未审核通过、7：审核中、8：审核通过
      });
      // 观众进入通知
      this.hub.on("ViewerEntryNotice", (res, onlineCount) => {
        let userinfo = res.UserInfo ? JSON.parse(res.UserInfo) : '';
        let model = {
          id: userinfo.id,
          isEntry: true,
          name: userinfo.nickName || userinfo.name,
          content: ''
        }
        this.$refs["barrage"].viewerEntry(model);
      });
      // 观众离开通知
      this.hub.on("ViewerLeaveNotice", msg => {
        console.log(msg, "观众离开通知");
      });
      // 留言删除通知（留言删除）
      this.hub.on("DeleteLiveCommentNotice", commentid => {
        this.$refs["barrage"].delBarrage(commentid);
      });
      // 观众留言通知（留言接收）
      this.hub.on("ViewerCommentNotice", comment => {
        let viewerName = '游客';
        if (comment.UserInfo) {
          viewerName = JSON.parse(comment.UserInfo).nickName || JSON.parse(comment.UserInfo).name;
        }
        let model = {
          id: comment.Id,
          isEntry: false,
          name: viewerName,
          text: comment.Content
        };
        console.log(model);
        this.$refs["barrage"].dataPush(model);
      });
      // 观众留言响应通知
      this.hub.on("ViewerCommentResponseNotice", res => {
        console.log('发送留言， 响应', res)
        //已授权
        if (!res.Result) {
          switch (this.liveStatus) {
            case 0:
              this.$toast.fail("直播尚未开始");
              break;
            case 1:
              this.$toast.fail(res.Message);
              break;
            case 2:
              this.$toast.fail("直播已经结束");
              break;
            case 3:
              this.$toast.fail("主播暂时不在");
              break;
            default:
              this.$toast.fail(res.Message);
              break;
          }
        }
      });
      //注册观众通知
      this.hub.on('RegisterVisitorNotice', comment => {
        this.$refs.liveInfo.showOpen(comment);
      })
      // 禁止留言
      this.hub.on("ForbidCommentNotice", msg => { });
      // 取消留言禁止
      this.hub.on("CancelForbidCommentNotice", msg => {

      });
      // 拉黑
      this.hub.on("PullblackNotice", msg => {
        console.log(msg, '拉黑');
      });
      // 取消拉黑
      this.hub.on("CancelPullblackNotice", msg => { });
    },
    //建立连接
    getHub () {
      let roomId = "roomId=" + this.roomid;
      this.hub = new signalR.HubConnectionBuilder()
        .withAutomaticReconnect()
        .withUrl(`${this.api.liveApi}/hub/live?${roomId}`)
        .build();
      // 连接回调
      this.hub
        .start()
        .then(e => {
          console.log(this.hub, "连接成功");
          this.viewerInit();
          this.getLoadMethod();
          // this.reContact(); // 超时重新连接
        })
        .then(errorMsg => {
          console.log(errorMsg, "err");
        });
    },
    // 重新连接
    reContact () {
      const that = this;
      (function (err) {
        setTimeout(() => {
          that.getHub();
        }, 200);
      });
    },
    // 观众进入 
    viewerInit () {
      let viewerInfo = {};
      viewerInfo.roomId = this.roomid;
      viewerInfo.userId = this.userInfo.userId;
      viewerInfo.memberId = this.userInfo.id;
      let model = {
        name: this.userInfo.name,
        nickName: this.userInfo.nickName,
        userId: this.userInfo.userId,
        avatarUrl: this.userInfo.avatarUrl,
      }
      viewerInfo.userInfo = JSON.stringify(model);
      console.log(viewerInfo, 'viewinfo')
      this.hub.invoke("ViewerEntry", this.roomid, viewerInfo);
    },
    statechange (e) {
      console.log(e);
    },
    //观众离开
    close () {
      if (this.userId && this.userInfo) {
        console.log("离开");
        this.hub.invoke("ViewerLeave", this.roomid, this.userId);
      }
    },
    ready () {
      console.log("ready");
    },
    play () {
      console.log("play");
      this.showBg = false;
    },
    ended () {
      console.log("ended");
      this.showBg = true;
    },
    liveStreamStop () {
      console.log("liveStreamStop");
      this.showBg = true;
    },
    error () {
      console.log("error");
      this.showBg = true;
    }
  }
};
</script>

<style lang="scss">
.prism-controlbar {
  display: none !important;
}
</style>
<style scoped lang='scss'>
html,
body,
#app,
.wx-pages {
  padding: 0;
  margin: 0;
  height: 100%;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
}
.layout {
  height: 100vh;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  background: #131825;
  &.home {
    padding-bottom: 0;
  }
  &.safari_home {
    .live {
      // height:auto;
      // overflow: hidden;
      // position: fixed;
      // left: 0;
      // top: 0;
      // bottom:0;
    }
  }
}
.live {
  width: 100vw;
  height: calc(100vh - 0.98rem);
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
}
.live_mask {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 2;
}
.live-bg {
  width: 100vw;
  height: calc(100vh - 0.98rem);
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: 0 auto;
  background-color: #000;
  transition: all 0.3s;
  &.hide {
    opacity: 0;
  }
}
.canvas {
  position: fixed;
  background: #fff;
  top: 50%;
  left: 50%;
  transform: translate(-1000px, 0);
  z-index: 99;
}
</style>

